import { useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { AppStateContext, NetworkStateContext } from "../common/utils/AppStateContext"
import { online, offline, selectOnline } from '../reducers/appSlice.js'
import { getToken, getRefreshToken } from "../reducers/authSlice"
import { decodeJWT } from "../common/utils/generalUtils.js"
import { signIn, signOut } from "../common/reducers/initContext.js"

export const NetworkStateProvider = ({ children }) => {
    const isOnline = useSelector(selectOnline);
    const [wsStatus, setWSStatus] = useState('closed');

    const value = useMemo(() => ({
        online,
        offline,
        isOnline,
        wsStatus,
        setWSStatus
    }), [isOnline, wsStatus]);

    return <NetworkStateContext.Provider value={value}>
        {children}
    </NetworkStateContext.Provider>
}

export const AppStateProvider = ({ children }) => {
    const token = useSelector(getToken);
    const refreshToken = useSelector(getRefreshToken);

    const value = useMemo(() => ({
        token,
        refreshToken,
        tokenData: token ? decodeJWT(token) : {},
        signIn,
        signOut
    }), [token, refreshToken]);

    return <AppStateContext.Provider value={value}>
        <NetworkStateProvider>
            {children}
        </NetworkStateProvider>
    </AppStateContext.Provider>
}
